export default __webpack_public_path__ + "static/media/work_ec-froms.94cdb21e.jpg";